import Link from "next/link";
import { Trans, useTranslation } from "next-i18next";

import { Message } from "@/components/elements";
import { LINKS } from "@/constants/links";
import { useCart } from "@/hooks/useCart";
import { useProducts } from "@/hooks/useProducts";
import { toTitleCase } from "@/utils/helpers";

import styles from "./OutOfStockProductWarnings.module.css";

export function OutOfStockProductWarnings() {
  const { t } = useTranslation();
  const { cart } = useCart();
  const products = useProducts();

  const outOfStockProductNames = cart.products
    .filter((cartItem) => {
      const product = products?.data?.productsById[cartItem.id];

      if (!product || product.status === "inactive") return false;

      return product.inventory < cartItem.quantity;
    })
    .map((cartItem) => {
      const product = products?.data?.productsById[cartItem.id];

      const { brand, title } = product;
      const productName = `${toTitleCase(brand)} ${t(title)}`;

      return { id: cartItem.id, productName };
    });

  if (outOfStockProductNames.length <= 0) {
    return null;
  }

  return (
    <div data-testid="out-of-stock-product-warnings">
      {outOfStockProductNames.map(({ id, productName }) => {
        return (
          <Message type="warning" key={id} className={styles.message}>
            <Trans
              i18nKey="shopping_cart_product_out_of_stock"
              values={{ productName }}
              components={{
                shopLink: <Link href={LINKS.SHOP} />,
              }}
            />
          </Message>
        );
      })}
    </div>
  );
}
